// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_ServiceStepsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_steps/service_steps/{service_id}
 *
 * Returns all production steps assigned to a service, ordered by position.
 * Wire shape: `dados: ProductionSteps_StepRow[]`.
 *
 * @see ProductionSteps_StepRow
 * @see So_service_steps_model::listByService()
 */
import type { ProductionSteps_StepRow } from './ProductionSteps_StepRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionSteps_ServiceStepsResponseDados = ProductionSteps_StepRow[];

export type ProductionSteps_ServiceStepsResponse = ApiResponse<ProductionSteps_ServiceStepsResponseDados>;

registerResponseContract('ProductionSteps_ServiceStepsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_production_step_id:                            { type: 'number',  required: true },
      so_production_step_name:                          { type: 'string',  required: true },
      so_production_step_description:                   { type: 'string',  required: false },
      so_production_step_default_duration_minutes:      { type: 'number',  required: false },
      so_production_step_active:                        { type: 'number',  required: true },
      so_production_step_qrcode:                        { type: 'string',  required: false },
      so_production_step_created_at:                    { type: 'string',  required: true },
      so_production_step_show_on_tv:                    { type: 'number',  required: false },
      so_production_step_reset_exempt:                  { type: 'number',  required: false },
      so_production_step_franchise_id:                  { type: 'number',  required: false },
      so_service_step_id:                               { type: 'number',  required: false },
      so_service_step_service_id:                       { type: 'number',  required: false },
      so_service_step_production_step_id:               { type: 'number',  required: false },
      so_service_step_order:                            { type: 'number',  required: false },
      so_service_step_is_terminal:                      { type: 'number',  required: false },
      so_service_step_franchise_id:                     { type: 'number',  required: false },
      so_service_step_created_at:                       { type: 'string',  required: false },
      so_additional_service_step_id:                    { type: 'number',  required: false },
      so_additional_service_step_additional_service_id: { type: 'number',  required: false },
      so_additional_service_step_production_step_id:    { type: 'number',  required: false },
      so_additional_service_step_order:                 { type: 'number',  required: false },
      so_additional_service_step_is_terminal:           { type: 'number',  required: false },
      so_additional_service_step_franchise_id:          { type: 'number',  required: false },
      so_additional_service_step_created_at:            { type: 'string',  required: false },
    },
  },
})
